import { render, staticRenderFns } from "./SlideMain.vue?vue&type=template&id=0c10a586"
import script from "./SlideMain.vue?vue&type=script&lang=js"
export * from "./SlideMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports